import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`To verify that your SSO configuration works, click `}<strong parentName="p">{`Login with new SSO`}</strong>{` in the GraphOS Studio wizard.
This button launches a new login session in a new browser tab. Once you successfully login using your new configuration, click `}<strong parentName="p">{`Next`}</strong>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      